import {
  Avatar,
  Box,
  Button,
  IconButton,
  InputAdornment,
  LinearProgress,
  TextField,
  Tooltip,
  Typography,
  Grid,
  Checkbox, MenuItem, Select, ListItemText, Input, InputLabel, FormControl
} from "@material-ui/core";
import { Info } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { AccountCircle, Delete, Email } from "@material-ui/icons";
import EmailValidator from "email-validator";
import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAppContext from "src/components/withAppContext";
import withAxios from "src/components/withAxios";
import { IDirectorRequest, IUser } from "src/services";
import { withSchoolContext } from "../../DirectorPage";
import Modal from "src/components/Modal";
import { IHeadCoach, ISubCoach, IAdministrator } from "./types";
import {
  ADD_DIRECTION_BUTTON_LABEL,
  ADD_DIRECTOR_FAILURE,
  ADD_DIRECTOR_INSTRUCTIONS,
  DELETE_DIRECTOR_FAILURE,
  DELETE_TOOLTIP_LABEL,
  DIRECTORS_HEADING,
  EMAIL_INPUT_LABEL,
  SETTINGS_PAGE_HEADER,
  VARSITY_COACH_INS
} from "./constants";
import { styles } from "./styles";
import { IDirectorSettingsState, IProps } from "./types";
//  interface IDirectorParams {
//   schoolId: string;
// }
interface IDirector extends IUser {
  superadmin?: boolean;
}

export default withAppContext(
  withSchoolContext(
    withStyles(styles)(
      withAxios(
        class extends Component<IProps, IDirectorSettingsState> {
          public readonly state = this.buildState({
            directorEmail: "",
            headCoachEmail: "",
            FirstName: "",
            LastName: "",
            coachFirstName: "",
            coachLastName: "",
            email: this.props?.appContext?.user?.email ?? "",
            error: false,
            submitting: false,
            ...(this.state as any),
            editModalDirectorIndex: "",
            modalStatus: "",
            adEditModal: false,
            coachEditModal: false,
            directors: [],
            headCoachDirectors: [],
            jvCoachList: [],
            loading: false,
            coachSports: [],
            editSports: [],
            particularCoachId: "",
            isMeadSeason: false,
            assignedSports: [],
            assignedSports2: [],
            subCoachEditModal: false,
            editSubCoachIndex: -1,
            editSubCoachSports: [],
             subCoachEmail: "",
            subCoachName: "",
            subCoachSports: [],
          });

          private readonly handleNewAdministratorEmailChange =
            this.stateInputEventHandler((v) => ({ directorEmail: v }));

          private readonly handleNewHeadCoachEmailChange =
            this.stateInputEventHandler((v) => ({ headCoachEmail: v }));

            //    private readonly handleNewSubCoachEmailChange =
            // this.stateInputEventHandler((v) => ({ subCoachEmail: v }));

          public handleFirstName = (
            e: React.ChangeEvent<HTMLInputElement>
          ) => {
            const { value } = e.target;
            this.setState((prevState) => ({
              ...prevState,
              FirstName: value,
            }));
          };

           public handleSubCoachFirstName = (
            e: React.ChangeEvent<HTMLInputElement>
          ) => {
            const { value } = e.target;
            this.setState((prevState) => ({
              ...prevState,
              subCoachName: value,
            }));
          };

          public handleLastName = (
            e: React.ChangeEvent<HTMLInputElement>
          ) => {
            const { value } = e.target;
            this.setState((prevState) => ({
              ...prevState,
              LastName: value,
            }));
          };
          public handlecoachFirstName = (
            e: React.ChangeEvent<HTMLInputElement>
          ) => {
            const { value } = e.target;
            this.setState((prevState) => ({
              ...prevState,
              coachFirstName: value,
            }));
          };

          public handlecoachLastName = (
            e: React.ChangeEvent<HTMLInputElement>
          ) => {
            const { value } = e.target;
            this.setState((prevState) => ({
              ...prevState,
              coachLastName: value,
            }));
          };
          public readonly handleSportsChange = (e: React.ChangeEvent<any>) => {
            this.setState({ coachSports: e.target.value });
          }

          public readonly handleSportsEdit = (e: React.ChangeEvent<any>) => {
            this.setState({ editSports: e.target.value });
          }


          public readonly renderSelectValues = (selected: string[]) =>
            selected.join(", ");

          public loadAdDirectors = () =>
            void this.runCancellableStatefulAsync(
              this,
              {
                loading: true,
              },
              {
                loading: undefined,
              },
              async () => {
                try {
                  const schoolId = String(this.props.school.id);
                  const directorsData =
                    // await this.buildGetWithParams<IUser[], IDirectorParams>(
                    //     this,
                    //     "/school/directorlistAD"
                    // )({ schoolId });
                    await this.buildGet<IUser[]>(
                      this,
                      `/school/directorlistAD/${schoolId}`
                    )()
                  console.log(" res of director::::::::::::", directorsData, this.props)
                  const adminDirectors = directorsData.filter((director: any) => director.headcoach === false 
                  &&  director?.jrcoachss === false);
                  const headCoachDirector = directorsData.filter((director: any) => director.headcoach === true
                  &&  director?.jrcoachss === false);
                  const JvCoachesList = directorsData.filter((director: any) => director?.jrcoachss === true);
                  this.setState({ directors: adminDirectors, headCoachDirectors: headCoachDirector, jvCoachList: JvCoachesList });
                  const assignSport: any = await this.buildGet<IUser>(this, `/coaches/getAllHeadCoach/${this.props.school.id}`)()
                  console.log("res=========assignSport", JvCoachesList,assignSport)
                  this.setState({ assignedSports: assignSport?.data })
                  this.setState({ assignedSports2: assignSport?.data })
                } catch (error) {
                  console.error("Failed to load directors", error);
                  window.alert("Failed to load directors");
                }
              },
              () => {
                this.setState({ loading: undefined });
                window.alert("Error loading templates");
              }
            );

          public readonly GetHeadCoach = (UserId: number) => {
            // const FirstName = (this.state as any).FirstName;
            // const LastName = (this.state as any).LastName;
            // const {coachSports} = this.state;
            return void this.runCancellableStatefulAsync(
              this,
              {},
              {
                directorEmail: "",
              },
              async () => {
                const hhheadcoch = await this.buildPost<{ userId: any, schoolId: any }, any>(
                  this,
                  "/coaches/getHeadCoach"
                )({
                  userId: UserId,
                  schoolId: this.props.school.id,

                });
                this.setState((prevState) => ({
                  ...(prevState as any),

                  particularCoachId: hhheadcoch.data.sportId,
                  editSports: hhheadcoch.data.sportId
                }));
              },
              () => {
                window.alert(ADD_DIRECTOR_FAILURE);
              }
            );
          };

          public componentDidMount = async () => {         
            const res: any = await this.buildGet<IUser>(this, `/school/getOneSchools/${this.props.school.id}`)()
            console.log("res=========isMidseason", res)
            // this.props.loadDirectors();
            this.setState({ isMeadSeason: res?.data?.ismidseason })
            this.loadAdDirectors();

          }

          public handleRadioChange = async (Email: any, schoolid: number, index: number) => {
            const testArray = [...this.state.directors];
            if (testArray?.length > 0) {

              testArray.map((Item, index2) => {
                testArray[index2].superadmin = false;

              })
              testArray[index].superadmin = true;
              this.setState({ directors: testArray })
            }

            try {
              // if(FirstName !== "" && LastName !== "") {
              const response = await this.buildPut<any, void>(this, 'payment/changeMainAD')({
                email: Email,
                schoolId: schoolid
              });
              console.log("resp", response)
              // if (response) {
              //  window.alert("User details updated successfully!");
              // this.props.loadDirectors();  
              this.loadAdDirectors();
              // }
              // }else{
              //   window.alert("Firstname and Lastname both are required.");
              // }
            } catch (error) {
              console.error("Error updating user details:", error);
              window.alert("Failed to update user details.");
            }

          }

          public openAdEditModal = (directorIndex: number, status: string) => {

            this.setState((prevState) => ({
              ...(prevState as any),
              editModalDirectorIndex: directorIndex,
              adEditModal: status === "Admin" ? true : false, modalStatus: status,
              coachEditModal: status === "Coach" ? true : false
            }));
          };

          public closeAdEditModal = () => {
            this.setState((prevState) => ({
              ...(prevState as any),
              editModalDirectorIndex: -1,
              adEditModal: false,
              coachEditModal: false
            }));
          };

        
          public readonly handleResendInvite =
            (user: any, role: "ADMIN" | "HEAD" | "SUB") => async () => {
              const invitedRole = role === "ADMIN" ? "AD" : role === "HEAD" ? "headcoach" : "coach";
              const payload = {
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
                schoolId: this.props.school.id,
                invited_role: invitedRole,
                user_id: user.id
              };
              try {
                await this.buildPost<typeof payload, any>(
                  this,
                  "/resend-invitation"
                )(payload);
                window.alert("Invite resent successfully.");
                this.loadAdDirectors();
              } catch (error) {
                window.alert("Failed to resend invite.");
              }
            };

         public handleCopyInviteLink = (director: any, role: string) => {
  const link = director?.invitationLinkUrl;

  if (!link) {
    alert("No invitation link found");
    return;
  }

  navigator.clipboard.writeText(link)
    .then(() => {
      alert("Invite link copied!");
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
      alert("Failed to copy link");
    });
};


          public render() {
            const FirstName = (this.state as any).FirstName;
            const LastName = (this.state as any).LastName;
            const coachFirstName = (this.state as any).coachFirstName;
            const coachLastName = (this.state as any).coachLastName;
            const {
              appContext: { user },
              classes } = this.props;
            const { directors, loading, coachSports, headCoachDirectors, isMeadSeason, jvCoachList } = this.state;
            const { sports } = this.props;
            return (
              <>
                <Page
                  header={SETTINGS_PAGE_HEADER}
                  subtitle={ADD_DIRECTOR_INSTRUCTIONS}
                >
                  <Box height="1px">
                    {loading && <LinearProgress />}
                  </Box>
                  <Tooltip 
          enterTouchDelay={0} 
          leaveTouchDelay={4000} 
          placement="right"
          title={<Typography style={{ fontSize: "14px" }}>To change or update the email address, please add a new school admin with the correct email.</Typography>}
        >
          <Info style={{ marginLeft: 5, fontSize: 25, cursor: "pointer" }} />
        </Tooltip>
                  <Box className={classes.formWrapper}>
                    <TextField
                      autoFocus={true}
                      label={EMAIL_INPUT_LABEL}
                      className={classes.emailInput}
                      value={this.state.directorEmail}
                      onChange={this.handleNewAdministratorEmailChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Email />
                          </InputAdornment>
                        ),
                      }}
                    // disabled={true}
                    />
                    <TextField
                      label="First Name"
                      className={classes.emailInput}
                      value={FirstName}
                      onChange={this.handleFirstName}
                      required={this.state.directorEmail ? true : false}  // Manual entry required if adding new director
                    />
                    <TextField
                      label="Last Name"
                      className={classes.emailInput}
                      onChange={this.handleLastName}
                      value={LastName}
                      required={this.state.directorEmail ? true : false}  // Manual entry required if adding new director
                    />
                    <Button
                      onClick={this.addDirector}
                      variant="contained"
                      color="primary"
                      // disabled={!this.canSubmit()}
                    >
                      {ADD_DIRECTION_BUTTON_LABEL}
                    </Button>
                  </Box>
                  {/* <Box display="flex" marginTop="10px">
                    
                    <Button
                      onClick={this.saveDirectorDetails}
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: "10px" }}
                    >
                      Save
                    </Button>
                  </Box> */}
                  <Box>
                    {directors?.length > 0 &&
                    <Typography variant="h5">{DIRECTORS_HEADING}</Typography>
          }
                    {/* <Box height="1px">
                    {loading && <LinearProgress />}
                  </Box> */}
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    {directors?.length > 0 && 
                      <thead>
                        <tr>
                          <th style={{ border: "1px solid #ddd", padding: "8px", width: "33%" }}>Email</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", width: "22%" }}>First Name</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", width: "18%" }}>Last Name</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", width: "10%" }}>Select School Admin</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px", width: "9%" }}>Status</th>
                          <th style={{ border: "1px solid #ddd", padding: "8px" }}>Actions</th>
                        </tr>
                      </thead>
          }
                      <tbody>
                        {/* {directors.map((director:any, index:number) => { */}
                        {/* {directors
  .filter((director: any) => director.headcoach === false)
  .map((director: any, index: number) => { */}
                        {directors.map((director: any, index: number) => {
                          const isDirectorCurrentUser = director.email === user.email;
                          return (
                            <tr key={director.id} style={{ borderBottom: "1px solid #ddd" }}>


                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                <div className="d-flex">
                                  <Avatar>
                                    <AccountCircle />
                                  </Avatar>

                                  <div className="director-email-text">
                                    {director.email}
                                    <span
                                      style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}
                                    >
                                      {(director as IDirector).superadmin ? "*" : ""}
                                    </span>
                                  </div>

                                </div></td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>{director.firstName}</td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>{director.lastName}</td>
                              <td><input style={{ marginLeft: "20px" }} type="radio" name="mainAd" value="Ad"
                                checked={(director as IDirector).superadmin === true}
                                onChange={() => this.handleRadioChange(director.email, this.props?.school.id, index)}
                              /></td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                <div style={{ fontSize: 12, color: "#555" }}>
                                    <div><strong>Status:</strong> {director.invitationStatus === "pending" ? "Sent (Not Accepted)" : "Accepted via Invite"}</div>
                                    {/* {director.invitationStatus === "pending" && <div><strong>Count:</strong> {director.invitationCount}</div>} */}
                                  </div>

                              </td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                  <div style={{ display: "flex", alignItems: "center"}}>
                                    <button
                                      onClick={() => this.openAdEditModal(index, "Admin")}
                                      style={{
                                        backgroundColor: "rgb(73, 75, 143)",
                                        color: "#fff",
                                        border: "none",
                                        padding: "5px 10px",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        marginRight: "5px",
                                      }}
                                    >
                                      Edit
                                    </button>
                                    {!isDirectorCurrentUser && (
                                      <Tooltip title={DELETE_TOOLTIP_LABEL} placement="left">
                                        <IconButton
                                          aria-label={DELETE_TOOLTIP_LABEL}
                                          onClick={this.deleteDirector(director, (director as IDirector).superadmin === true, "AD")}
                                        >
                                          <Delete />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </div>
                
                                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                    {director.invitationStatus === "pending" && (
                                      <>
                                        <button
                                          onClick={this.handleResendInvite(director, "ADMIN")}
                                          style={{
                                            backgroundColor: "#ffffff",
                                            color: "#494b8f",
                                            border: "1px solid #494b8f",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: 12,
                                          }}
                                        >
                                          Resend invite
                                        </button>
                                        <button
                                          onClick={() => this.handleCopyInviteLink(director, "ADMIN")}
                                          style={{
                                            backgroundColor: "#f5f5f5",
                                            color: "#333",
                                            border: "1px solid #ccc",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: 12,
                                          }}
                                        >
                                          Copy link
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Box>

                  {this.EditDirectorModal()}
                </Page>
                {/* //Coach Section */}
                {isMeadSeason === true &&
                  <div className="head-coch-inner">
                    {/* <h2>Add Head Coach</h2> */}
                    <Box className={classes.formWrapper}>
                    <div style={{ position: "relative", display: "inline-block",width:"100%" }}>
  <TextField
    // autoFocus={true}
    label={
      <span style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
        Add Varsity Head Coach Email
         <Tooltip 
          enterTouchDelay={0} 
          leaveTouchDelay={4000} 
          placement="right"
          title={<Typography style={{ fontSize: "14px" }}>{VARSITY_COACH_INS}</Typography>}
        >
          <Info style={{ marginLeft: 20, fontSize: 25, cursor: "pointer" }} />
        </Tooltip>       
      </span>
    }
    className={classes.emailInput}
    value={this.state.headCoachEmail}
    onChange={this.handleNewHeadCoachEmailChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Email />
        </InputAdornment>
      ),
    }}
  />
</div>

                     <TextField
                        label="First Name"
                        className={classes.emailInput}
                        value={coachFirstName}
                        onChange={this.handlecoachFirstName}
                        required={this.state.headCoachEmail ? true : false}  // Manual entry required if adding new director
                      />
                      <TextField
                        label="Last Name"
                        className={classes.emailInput}
                        onChange={this.handlecoachLastName}
                        value={coachLastName}
                        required={this.state.headCoachEmail ? true : false}  // Manual entry required if adding new director
                      />
                      <FormControl>
                        <InputLabel
                          className="select-input-coach" htmlFor="select-multiple-checkbox">
                          {"Sport"}
                        </InputLabel>
                        <Select
  label="Select sport"
  className={classes.emailInput}
  multiple={true}
  value={coachSports}
  input={<Input id="select-multiple-checkbox" />}
  renderValue={(selected) => {
    const blockedIds = [72, 74, 73, 68];

    const selectedLabels = (selected as number[])
      .filter((id) => !blockedIds.includes(id))
      .map((id) => sports.find((option) => option.id === id)?.name)
      .filter(Boolean);

    return selectedLabels.join(", ");
  }}
>
  {sports
    .filter((sport) => 
      this.props.school?.isAdSurvey 
        ? [72, 74, 73, 68].includes(sport.id) // Show only AD sports for AD survey
        : ![72, 74, 73, 68].includes(sport.id) // Hide AD sports for regular surveys
    )
    .map((sport) => {
      const { assignedSports } = this.state;
      const isAssigned = assignedSports.includes(sport.id);

      return (
        <MenuItem
          key={sport.id}
          value={sport.id}
          onClick={(e) => {
            if (isAssigned) {
              e.preventDefault();
              alert(`${sport.name} is already assigned.`);
              return;
            }

            const updatedSports = coachSports.includes(sport.id)
              ? coachSports.filter((id: number) => id !== sport.id)
              : [...coachSports, sport.id];

            this.setState({ coachSports: updatedSports });
          }}
        >
          <Checkbox checked={coachSports.includes(sport.id)} />
          <ListItemText primary={sport.name} />
        </MenuItem>
      );
    })}
</Select>

                      </FormControl>
                      <Button
                        onClick={this.addHeadCoach}
                        variant="contained"
                        color="primary"
                        // disabled={!this.canSubmit2()}
                      >
                        {ADD_DIRECTION_BUTTON_LABEL}
                      </Button>
                    </Box>
                    {/* <Box display="flex" marginTop="10px">
                    
                    <Button
                      onClick={this.saveDirectorDetails}
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: "10px" }}
                    >
                      Save
                    </Button>
                  </Box> */}
                   {headCoachDirectors?.length > 0 && <h2>  Varsity Head Coach List</h2> }
                    <Box>
                      {/* <Typography variant="h5">{DIRECTORS_HEADING}</Typography> */}
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        {headCoachDirectors?.length > 0 &&
                          <thead>
                            <tr>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "30%" }}>Email</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "20%" }}>First Name</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "18%" }}>Last Name</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "17%" }}>Sport</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "9%" }}>Status</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Actions</th>
                            </tr>
                          </thead>
                        }

                        <tbody>
                          {/* {directors.map((director:any, index:number) => { */}
                          {/* {directors
  .filter((director: any) => director.headcoach === true)
  .map((director: any, index: number) => {  */}
                          {headCoachDirectors.map((director: any, index: number) => {
                            const isDirectorCurrentUser = director.email === user.email;
                            return (
                              <tr key={director.id} style={{ borderBottom: "1px solid #ddd" }}>


                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <div className="d-flex">
                                    <Avatar>
                                      <AccountCircle />
                                    </Avatar>

                                    <div className="director-email-text">
                                      {director.email}
                                      <span
                                        style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}
                                      >
                                        {(director as IDirector).superadmin ? "*" : ""}
                                      </span>
                                    </div>

                                  </div></td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{director.firstName}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{director.lastName}</td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}><div className="director-sport-ttin">{director?.sport?.map((sport: any) => (
                                  <ListItemText primary={sport.name} />
                                ))}
                                </div>
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <div style={{ fontSize: 12, color: "#555" }}>
                                     <div><strong>Status:</strong> {director.invitationStatus === "pending" ? "Sent (Not Accepted)" : "Accepted via Invite"}</div>
                                    {/* {director.invitationStatus === "pending" && <div><strong>Count:</strong> {director.invitationCount}</div>} */}
                                    </div>
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                    <div style={{ display: "flex", alignItems: "center"}}>
                                      <button
                                        onClick={() => {
                                          this.openAdEditModal(index, "Coach");
                                          this.GetHeadCoach(director.id)
                                        }
                                        }
                                        style={{
                                          backgroundColor: "rgb(73, 75, 143)",
                                          color: "#fff",
                                          border: "none",
                                          padding: "5px 10px",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                          marginRight: "5px",
                                        }}
                                      >
                                        Edit
                                      </button>
                                      {!isDirectorCurrentUser && (
                                        <Tooltip title={DELETE_TOOLTIP_LABEL} placement="left">
                                        <IconButton
      aria-label={DELETE_TOOLTIP_LABEL}
      onClick={this.deleteVarsityCoach(director)}
    >
      <Delete />
    </IconButton>
                                        </Tooltip>
                                      )}
                                    </div>
                                    
                                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                                       {director.invitationStatus === "pending" && (
                                         <>
                                           <button
                                             onClick={this.handleResendInvite(director, "HEAD")}
                                             style={{
                                               backgroundColor: "#ffffff",
                                               color: "#494b8f",
                                               border: "1px solid #494b8f",
                                               padding: "4px 8px",
                                               borderRadius: "4px",
                                               cursor: "pointer",
                                               fontSize: 12,
                                             }}
                                           >
                                             Resend invite
                                           </button>
                                           <button
                                             onClick={() => this.handleCopyInviteLink(director, "ADMIN")}
                                             style={{
                                               backgroundColor: "#f5f5f5",
                                               color: "#333",
                                               border: "1px solid #ccc",
                                               padding: "4px 8px",
                                               borderRadius: "4px",
                                               cursor: "pointer",
                                               fontSize: 12,
                                             }}
                                           >
                                             Copy link
                                           </button>
                                         </>
                                       )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </Box>
                    {this.EditHeadCoachModal()}
                    {this.EditSubCoachModal()}
                  </div>
                }

{/* JV data */}
{isMeadSeason === true &&
                  <div className="head-coch-inner">

                     {/* <Box className={classes.formWrapper}>
                    <div style={{ position: "relative", display: "inline-block",width:"100%" }}>
  <TextField
    // autoFocus={true}
    label= "Add Sub Varsity Coach Email"
    className={classes.emailInput}
    value={this.state.subCoachEmail}
    onChange={this.handleNewSubCoachEmailChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Email />
        </InputAdornment>
      ),
    }}
  />
</div>

                     <TextField
                        label="Name"
                        className={classes.emailInput}
                        value={this.state.subCoachName}
                        onChange={this.handleSubCoachFirstName}
                        required={this.state.subCoachEmail ? true : false}
                      />
                     
                      <FormControl>
                        <InputLabel
                          className="select-input-coach" htmlFor="select-multiple-checkbox">
                          {"Sport"}
                        </InputLabel>

<Select
  label="Select sport"
  multiple={true}
   value={this.state.subCoachSports}
        onChange={(e) => this.setState({ subCoachSports: e.target.value })}
        renderValue={(selected) => {
    const blockedIds = [72, 74, 73, 68];

    const selectedLabels = (selected as number[])
      .filter((id) => !blockedIds.includes(id))
      .map((id) => sports.find((option) => option.id === id)?.name)
      .filter(Boolean);

    return selectedLabels.join(", ");
  }}
>
    {sports
      .filter((sport) => 
        this.props.school?.isAdSurvey 
          ? [72, 74, 73, 68].includes(sport.id) // Show only AD sports for AD survey
          : ![72, 74, 73, 68].includes(sport.id) // Hide AD sports for regular surveys
      )
      .map((s) => (
          <MenuItem key={s.id} value={s.id}>
             <Checkbox checked={this.state.subCoachSports.includes(s.id)} />
            <ListItemText primary={s.name} />
          </MenuItem>
        ))} 
</Select>

                      </FormControl>
                      <Button
                        onClick={this.addSubCoach}
                        variant="contained"
                        color="primary"
                        // disabled={!this.canSubmit2()}
                      >
                        {ADD_DIRECTION_BUTTON_LABEL}
                      </Button>
                    </Box> */}
                  {jvCoachList?.length > 0 && <h2> Sub Varsity Coach List</h2>}
              
                    <Box>
                      {/* <Typography variant="h5">{DIRECTORS_HEADING}</Typography> */}
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        {jvCoachList?.length > 0 &&
                          <thead>
                            <tr>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "34%" }}>Email</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "25%" }}>Name</th>
                              {/* <th style={{ border: "1px solid #ddd", padding: "8px", width: "21%" }}>Sport</th>
                              <th style={{ border: "1px solid #ddd", padding: "8px", width: "9%" }}>Status</th> */}
                              <th style={{ border: "1px solid #ddd", padding: "8px" }}>Actions</th>
                            </tr>
                          </thead>
                        }

                        <tbody>
                          {jvCoachList.map((director: any, index: number) => {
                            const isDirectorCurrentUser = director.email === user.email;
                            return (
                              <tr key={director.id} style={{ borderBottom: "1px solid #ddd" }}>


                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <div className="d-flex">
                                    <Avatar>
                                      <AccountCircle />
                                    </Avatar>

                                    <div className="director-email-text">
                                      {director.email}
                                      <span
                                        style={{ color: "red", fontWeight: "bold", fontSize: "16px" }}
                                      >
                                        {(director as IDirector).superadmin ? "*" : ""}
                                      </span>
                                    </div>

                                  </div></td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{director.firstName}</td>
                                {/* <td style={{ border: "1px solid #ddd", padding: "8px" }}><div className="director-sport-ttin">{director?.sport?.map((sport: any) => (
                                  <ListItemText primary={sport.name} />
                                ))}
                                </div>
                                </td>
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <div style={{ fontSize: 12, color: "#555" }}>
                                     <div><strong>Status:</strong> {director.invitationStatus === "pending" ? "Sent (Not Accepted)" : "Accepted via Invite"}</div>

                                    </div>
                                   
                                </td> */}
                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                    <div style={{ display: "flex", alignItems: "center"}}>
                                      {/* <button
                                        onClick={() => {
                                         

                                           this.setState({
        subCoachEditModal: true,
        editSubCoachIndex: index,
        editSubCoachSports: director?.sport?.map((s: any) => s.name) || []
      });
                                        }
                                        }
                                        style={{
                                          backgroundColor: "rgb(73, 75, 143)",
                                          color: "#fff",
                                          border: "none",
                                          padding: "5px 10px",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                          marginRight: "5px",
                                        }}
                                      >
                                        Edit
                                      </button> */}


                                      {!isDirectorCurrentUser && (
                                        <Tooltip title={DELETE_TOOLTIP_LABEL} placement="left">
                                          <IconButton
                                            aria-label={DELETE_TOOLTIP_LABEL}
                                            onClick={this.deleteSubVarsityCoach(director)}
                                          >
                                            <Delete />
                                          </IconButton>
                                        </Tooltip>
                                      )}

                                    
                                      {/* {director.invitationStatus === "pending" && <button
                                        onClick={this.handleResendInvite(director, "SUB")}
                                        style={{
                                          backgroundColor: "#ffffff",
                                          color: "#494b8f",
                                          border: "1px solid #494b8f",
                                          padding: "4px 8px",
                                          borderRadius: "4px",
                                          cursor: "pointer",
                                          minWidth: "90px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        Resend invite
                                      </button>} */}
                                  
                                    </div>
{/*                                  
                                    {director.invitationStatus === "pending" && <button
  onClick={() => this.handleCopyInviteLink(director, "ADMIN")}
  style={{
    backgroundColor: "#f5f5f5",
    color: "#333",
    border: "1px solid #ccc",
    padding: "4px 8px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: 12,
  }}
>
  Copy link
</button>} */}

                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </Box>
                    {this.EditHeadCoachModal()}
                  </div>
          }
              </>
            );

          }

          private EditHeadCoachModal() {
            const coachEditModal = (this.state as any).coachEditModal;
            const { sports } = this.props;
            const editModalDirectorIndex = (this.state as any).editModalDirectorIndex;
            const modalStatus = (this.state as any).modalStatus;
            const particularCoachId = (this.state as any).particularCoachId;
            console.log("sports seletion", particularCoachId, editModalDirectorIndex, modalStatus)
            const { headCoachDirectors, editSports } = this.state;
            const currentDirector = headCoachDirectors[editModalDirectorIndex] ?? {};
            if (!coachEditModal) {
              return null;
            }
            const isDirectorEmailUnique =
              headCoachDirectors.find((director: any) => director.email === currentDirector.email) ===
              undefined;
            const isDirectorEmailValid = EmailValidator.validate(currentDirector.email ?? "");
            console.log(isDirectorEmailUnique, isDirectorEmailValid)
            const handleFieldChange = (field: string, value: string) => {
              const updatedDirectors = [...headCoachDirectors];
              updatedDirectors[editModalDirectorIndex] = {
                ...updatedDirectors[editModalDirectorIndex],
                [field]: value,
              };

              this.setState({ headCoachDirectors: updatedDirectors });
            };

            const saveDirectorDetails = async () => {
              const errors = [];
              
              // Validate email (not blank and valid format)
              const isEmailProvided = currentDirector.email.trim() !== "";
              const isEmailValid = EmailValidator.validate(currentDirector.email.trim());
            
              if (!isEmailProvided) {
                errors.push("Email cannot be blank.");
              } else if (!isEmailValid) {
                errors.push("Invalid email format.");
              }else if (currentDirector.firstName.trim() === "") {
                errors.push("First name is required.");
              }else if (currentDirector.lastName.trim() === "") {
                errors.push("Last name is required.");
              }else if (editSports?.length === 0) {
                errors.push("At least one sport must be selected.");
              }
            
              // If there are errors, show them and stop the execution
              if (errors.length > 0) {
                window.alert(errors.join("\n"));
                return;
              }
            
              try {
                // Proceed if all fields are valid
                const response = await this.buildPut<any, { success: boolean; message: string, status: boolean }>(this, '/coaches/updateHeadCoach')({
                  schoolId: this.props.school.id,
                  userId: currentDirector.id ?? 0,
            
                  email: currentDirector.email,
                  firstName: currentDirector.firstName,
                  lastName: currentDirector.lastName,
                  sportId: editSports
                });
            
                console.log("Response from API:", response);
                this.loadAdDirectors();
                
                if (response.status === true) {
                  window.alert("Teacher details updated successfully");
                  this.closeAdEditModal();
                } else {
                  window.alert("Email already exists");
                  this.closeAdEditModal();
                }
              } catch (error) {
                console.error("Error updating teacher details:", error);
                window.alert("Failed to update teacher details.");
              }
            };
            

            return (
              <Modal className="modal-dirctor-iinner" open={coachEditModal} closeModal={this.closeAdEditModal}>
                <Grid
                  style={{ height: "100%" }}
                  container={true}
                  direction="column"
                  justifyContent="space-between"
                >
                  <div

                  >
                    <div className="edit-director">
                      <h3>
                        Edit Varsity Head Coach
                        {/* {modalStatus === "Admin" ? "Edit Director":
                       "Edit Head Coach"} */}
                      </h3>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={this.closeAdEditModal}
                      >
                        <CloseIcon />
                      </span>
                    </div>
                   
                    <div style={{ marginBottom: "16px" }}>
                            <span style={{ display: "flex", alignItems: "center" }}>

                      <label>Email<span style={{ color: "red" }}>*</span>
                      
                      </label>

                      <Tooltip 
          enterTouchDelay={0} 
          leaveTouchDelay={4000} 
          placement="right"
          title={<Typography style={{ fontSize: "14px" }}>{"To change or update the email address, please add a new varsity coach with the correct email."}</Typography>}
        >
          <Info style={{ marginLeft: 5, fontSize: 20, marginBottom:8, cursor: "pointer" }} />
        </Tooltip>
        </span>
                      <input
                        type="email"
                        value={currentDirector.email || ""}
                        onChange={(e) =>
                          handleFieldChange("email", e.target.value)
                        }
                        disabled={true}

                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "16px" }}>
                      <label>First Name<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        value={currentDirector.firstName || ""}
                        onChange={(e) =>
                          handleFieldChange("firstName", e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "16px" }}>
                      <label>Last Name<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        value={currentDirector.lastName || ""}
                        onChange={(e) =>
                          handleFieldChange("lastName", e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                    {/* {modalStatus === "Coach" && */}
                    <div style={{ marginBottom: "16px" }}>
                      <FormControl>
                        <InputLabel
                          className="select-input-coach" htmlFor="select-multiple-checkbox">
                          {"Sport"}<span style={{ color: "red" }}>*</span>
                        </InputLabel>
                    <Select
  label="Select sport"
  multiple={true}
  value={editSports}
  input={<Input id="select-multiple-checkbox" />}
  renderValue={(selected) => {
    const selectedLabels = (selected as number[])
      .map((id) => sports.find((option) => option.id === id)?.name)
      .filter(Boolean);
    return selectedLabels.join(", ");
  }}
>
  {sports
    .filter((sport) => 
      this.props.school?.isAdSurvey 
        ? [72, 74, 73, 68].includes(sport.id) // Show only AD sports for AD survey
        : ![72, 74, 73, 68].includes(sport.id) // Hide AD sports for regular surveys
    )
    .map((sport) => {
      const { assignedSports2, headCoachDirectors } = this.state;
      const isAssigned = assignedSports2.includes(sport.id);
      const isAlreadySelected = editSports.includes(sport.id);

      return (
        <MenuItem
          key={sport.id}
          value={sport.id}
          onClick={(e) => {
            const isSportInCoaches = headCoachDirectors.some((coach: any) =>
              coach.sport.includes(sport.id)
            );

            if (isAlreadySelected) {
              if (isAssigned || isSportInCoaches) {
                this.setState({
                  assignedSports2: assignedSports2.filter((id: number) => id !== sport.id),
                  editSports: editSports.filter((id: number) => id !== sport.id),
                });
              }
            } else {
              if (isAssigned) {
                e.preventDefault();
                alert(
                  `${sport.name} is already assigned to another coach. Please remove it from the current coach before assigning it to a different one.`
                );
                return;
              }

              this.setState({
                editSports: [...editSports, sport.id],
                assignedSports2: [...assignedSports2, sport.id],
              });
            }
          }}
        >
          <Checkbox checked={isAlreadySelected} />
          <ListItemText primary={sport.name} />
        </MenuItem>
      );
    })}
</Select>


                      </FormControl>
                    </div>
                    {/* // } */}

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>

                      <button
                        onClick={saveDirectorDetails}
                        // disabled={!(isDirectorEmailUnique && isDirectorEmailValid && this.state.adfirstName?.trim() && this.state.adlastName?.trim())}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: "#494b8f",
                          color: "#fff",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </Grid>
              </Modal>
            );
          }

           private EditSubCoachModal() {
  const { subCoachEditModal, editSubCoachIndex, editSubCoachSports, jvCoachList } = this.state;
  const { sports } = this.props;

  if (!subCoachEditModal) {return null;}

  const coach = jvCoachList[editSubCoachIndex];

  const handleSave = async () => {
    if (!coach?.firstName?.trim()) {
      alert("Name is required");
      return;
    }
    if (editSubCoachSports.length === 0) {
      alert("Select at least one sport");
      return;
    }

    await this.buildPut<ISubCoach, void>(
      this,
      `coach/${coach.id}`
    )({
      active: true,
      name: coach.firstName,
      schoolId: this.props.school.id,
      email: coach.email.trim().toLowerCase(),
      sports: editSubCoachSports
        .map((sportName: string) => {
          const sport = sports.find(s => s.name === sportName);
          return sport ? sport.id : -1;
        })
        .filter((id: number) => id !== -1),
    });

    this.setState({ subCoachEditModal: false });
    this.loadAdDirectors();
  };

  return (
    <Modal open={subCoachEditModal} closeModal={() => this.setState({ subCoachEditModal: false })}>
       <Grid
                  style={{ height: "100%" }}
                  container={true}
                  direction="column"
                  justifyContent="space-between"
                >
      
<div className="edit-director">
                      <h3>Edit Sub Varsity Coach</h3>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => this.setState({ subCoachEditModal: false })}
                      >
                        <CloseIcon />
                      </span>
                    </div>

     <div style={{ marginBottom: "16px" }}>
        <span style={{ display: "flex", alignItems: "center" }}>

                      <label>Email<span style={{ color: "red" }}>*</span>
                      
                      </label>

                      <Tooltip 
          enterTouchDelay={0} 
          leaveTouchDelay={4000} 
          placement="right"
          title={<Typography style={{ fontSize: "14px" }}>{"To change or update the email address, please add a new sub varsity with the correct email."}</Typography>}
        >
          <Info style={{ marginLeft: 5, fontSize: 20, marginBottom:8, cursor: "pointer" }} />
        </Tooltip>
        </span>
                      <input
                        type="email"
                        value={coach.email}
                        disabled={true}

                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "16px" }}>
                      <label>First Name<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                       value={coach.firstName}
        onChange={(e) => {
          const list = [...jvCoachList];
          list[editSubCoachIndex].firstName = e.target.value;
          this.setState({ jvCoachList: list });
        }}
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

      <Select
        multiple={true}
        value={editSubCoachSports}
        onChange={(e) => this.setState({ editSubCoachSports: e.target.value })}
        renderValue={(selected: any) => selected.join(", ")}
      >
        {sports.map((s) => (
          <MenuItem key={s.id} value={s.name}>
            <Checkbox checked={editSubCoachSports.includes(s.name)} />
            <ListItemText primary={s.name} />
          </MenuItem>
        ))}
      </Select>

      <Button onClick={handleSave} color="primary" variant="contained">
        Save
      </Button>
      </Grid>
    </Modal>
    
  );
}
          private EditDirectorModal() {
            const adEditModal = (this.state as any).adEditModal;
            const editModalDirectorIndex = (this.state as any).editModalDirectorIndex;
            const { directors } = this.state;
            const currentDirector = directors[editModalDirectorIndex] ?? {};
            if (!adEditModal) {
              return null;
            }
            const isDirectorEmailUnique =
              directors.find((director: any) => director.email === currentDirector.email) ===
              undefined;
            const isDirectorEmailValid = EmailValidator.validate(currentDirector.email ?? "");
            console.log(isDirectorEmailUnique, isDirectorEmailValid)
            const handleFieldChange = (field: string, value: string) => {
              const updatedDirectors = [...directors];
              updatedDirectors[editModalDirectorIndex] = {
                ...updatedDirectors[editModalDirectorIndex],
                [field]: value,
              };

              this.setState({ directors: updatedDirectors });
            };

            const saveDirectorDetails = async () => {
              const errors = [];
              
              // Validate email (not blank and valid format)
              const isEmailProvided = currentDirector.email.trim() !== "";
              const isEmailValid = EmailValidator.validate(currentDirector.email.trim());
            
              if (!isEmailProvided) {
                errors.push("Email cannot be blank.");
              } else if (!isEmailValid) {
                errors.push("Invalid email format.");
              }else if (currentDirector.firstName.trim() === "") {
                errors.push("First name is required.");
              }else if (currentDirector.lastName.trim() === "") {
                errors.push("Last name is required.");
              }
            
              // If there are validation errors, show them and stop execution
              if (errors.length > 0) {
                window.alert(errors.join("\n"));
                return;
              }
            
              try {
                // Proceed if all fields are valid
                const response = await this.buildPut<any, { success: boolean; message: string, status: boolean }>(this, 'user/updateUserAdmin')({
                  userId: currentDirector.id ?? 0,
                  email: currentDirector.email,
                  firstName: currentDirector.firstName,
                  lastName: currentDirector.lastName,
                });      
                console.log("Response from API:", response);
                this.loadAdDirectors();               
                if (response.status === true) {
                  window.alert("Director details updated successfully");
                  this.closeAdEditModal();
                } else {
                  window.alert("Email already exists");
                  this.closeAdEditModal();
                }
              } catch (error) {
                console.error("Error updating director details:", error);
                window.alert("Failed to update director details.");
              }
            };
            
            return (
              <Modal className="modal-dirctor-iinner" open={adEditModal} closeModal={this.closeAdEditModal}>
                <Grid
                  style={{ height: "100%" }}
                  container={true}
                  direction="column"
                  justifyContent="space-between"
                >
                  <div

                  >
                    <div className="edit-director">
                      <h3>Edit School Admin</h3>
                      <span
                        onClick={this.closeAdEditModal}
                        style={{ cursor: "pointer" }}
                      >
                        <CloseIcon />
                      </span>
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      {/* <label>Email<span style={{ color: "red" }}>*</span></label> */}
                       <span style={{ display: "flex", alignItems: "center" }}>

                      <label>Email<span style={{ color: "red" }}>*</span>
                      
                      </label>

                      <Tooltip 
          enterTouchDelay={0} 
          leaveTouchDelay={4000} 
          placement="right"
          title={<Typography style={{ fontSize: "14px" }}>{"To change or update the email address, please add a new school admin with the correct email."}</Typography>}
        >
          <Info style={{ marginLeft: 5, fontSize: 20, marginBottom:8, cursor: "pointer" }} />
        </Tooltip>
        </span>
                      <input
                        type="email"
                        value={currentDirector.email || ""}
                        onChange={(e) =>
                          handleFieldChange("email", e.target.value)
                        }
                        disabled={true}

                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "16px" }}>
                      <label>First Name<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        value={currentDirector.firstName || ""}
                        onChange={(e) =>
                          handleFieldChange("firstName", e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    <div style={{ marginBottom: "16px" }}>
                      <label>Last Name<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        value={currentDirector.lastName || ""}
                        onChange={(e) =>
                          handleFieldChange("lastName", e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "8px",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>

                      <button
                        onClick={saveDirectorDetails}
                        // disabled={!(isDirectorEmailUnique && isDirectorEmailValid && this.state.adfirstName?.trim() && this.state.adlastName?.trim())}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: "#494b8f",
                          color: "#fff",
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </Grid>
              </Modal>
            );
          }
       
            private readonly canSubmit = (): { isValid: boolean; errors: string[] } => {
              const FirstName = (this.state as any).FirstName;
              const LastName = (this.state as any).LastName;
               // Validate First Name
               const isFirstNameValid = FirstName?.trim().length > 0;
               
              // Validate Last Name
              const isLastNameValid = LastName?.trim().length > 0;
              // Initialize an array to hold error messages
              const errors: string[] = [];
             // Validate Email
             const directorEmail = this.state.directorEmail;
             const isEmailProvided = Boolean(directorEmail && directorEmail.trim());
             const isEmailValid = EmailValidator.validate(directorEmail.trim());
             if (!isEmailProvided) {
               errors.push("Email cannot be blank.");
             } else if (!isEmailValid) {
                 errors.push("Invalid email format.");
               }else if (!isFirstNameValid) {
                errors.push("First Name cannot be blank.");
              }else if (!isLastNameValid) {
                errors.push("Last Name cannot be blank.");
              }
              // Return validation result and errors
              return { isValid: errors.length === 0, errors };
            };
            
          private readonly canSubmit2 = (): { isValid: boolean; errors: string[] } => {
            const { headCoachEmail, coachSports } = this.state;
            const coachFirstName = (this.state as any).coachFirstName;
            const coachLastName = (this.state as any).coachLastName;
             // Validate First Name (should not be empty)
            const isFirstNameValid = Boolean(coachFirstName);
             // Validate Last Name (should not be empty)
             const isLastNameValid = Boolean(coachLastName);
              // Validate Sport selection (at least one sport must be selected)
            const isSportSelected = coachSports.length > 0;
            // Initialize an array to hold error messages
            const errors: string[] = [];
          
            // Validate email using EmailValidator
            const isEmailValid = EmailValidator.validate(headCoachEmail?.trim());
            const isEmailProvided = Boolean(headCoachEmail && headCoachEmail.trim());
            if (!isEmailProvided) {
              errors.push("Email address cannot be blank.");
            }else if (!isEmailValid) {
              errors.push("Invalid email address.");
            }else if (!isFirstNameValid) {
              errors.push("First Name cannot be empty.");
            }else if (!isLastNameValid) {
              errors.push("Last Name cannot be empty.");
            }else if (!isSportSelected) {
              errors.push("At least one sport must be selected.");
            }
          
            // Return validation result and errors
            return { isValid: isEmailValid && isFirstNameValid && isLastNameValid && isSportSelected, errors };
          };
          
          private readonly deleteDirector = (director: IUser, mainAd: any, status: string) => () =>
            void this.runCancellableStatefulAsync(
              this,
              {},
              {},
              async () => {
                if(status === "AD"){
                if (mainAd) {
                  alert("You cannot delete the current school admin. Please select a new school admin first.");
                  return;
                } else {
                  const isConfirmed = window.confirm(
                    "Are you sure you want to delete this school admin? \nOnce deleted, the school admin will no longer be able to log in or view survey results."
                  );
                  if (!isConfirmed) {
                    return; // User ne "Cancel" kiya toh delete nahi hoga
                  }
                }
              }
          
                if (director.email === undefined) {
                  return;
                }
                await this.buildPut<IDirectorRequest, void>(
                  this,
                   "director"
                  )({
                  email: director.email,
                  schoolId: this.props.school.id,
                  firstName: "",
                  lastName: "",
                });
          
                // this.props.loadDirectors();
                this.loadAdDirectors();
              },
              () => {
                window.alert(DELETE_DIRECTOR_FAILURE);
              }
            );
          
            private readonly deleteVarsityCoach = (director: IUser) => () =>
              void this.runCancellableStatefulAsync(
                this,
                {},
                {},
                async () => {
                  const isConfirmed = window.confirm(
                    "Are you sure you want to delete this coach? \nOnce deleted, the coach will no longer be able to log in or view survey results. All previously collected data will still be available to the Athletic Director."
                  );
                  if (!isConfirmed) {
                    return; 
                  }
            
                  if (director.email === undefined) {
                    return;
                  }
            
                  await this.buildPut<IDirectorRequest, void>(this, "director")({
                    email: director.email,
                    schoolId: this.props.school.id,
                    firstName: '',
                    lastName: '',
                  });           
                  // this.props.loadDirectors();
                  this.loadAdDirectors();
                },
                () => {
                  window.alert(DELETE_DIRECTOR_FAILURE);
                }
              );
               private readonly deleteSubVarsityCoach = (director: IUser) => () =>
              void this.runCancellableStatefulAsync(
                this,
                {},
                {},
                async () => {
                   const isConfirmed = window.confirm(
                    "Are you sure you want to delete this coach? \nOnce deleted, the coach will no longer be able to log in or view survey results. All previously collected data will still be available to the Athletic Director."
                  );
                  if (!isConfirmed) {
                    return; // User ne "Cancel" kiya toh delete nahi hoga
                  }
            
                  if (director.email === undefined) {
                    return;
                  }
            
                  await this.buildPut<IDirectorRequest, void>(this, "director")({
                    email: director.email,
                    schoolId: this.props.school.id,
                    firstName: '',
                    lastName: '',
                  });           
                  // this.props.loadDirectors();
                  this.loadAdDirectors();
                },
                () => {
                  window.alert(DELETE_DIRECTOR_FAILURE);
                }
              );
            
            private readonly addDirector = () => {
              const { isValid, errors } = this.canSubmit();
               const {
              appContext: { user },
               } = this.props;

                            // DUPLICATE EMAIL CHECK (Varsity Head Coach list)
  const alreadyExists = this.state.directors.some(
    (coach: any) => coach.email?.toLowerCase() === this.state.directorEmail.trim().toLowerCase()
  );

  if (alreadyExists) {
    window.alert(
      "This email is already added as a school admin. You can’t add it again."
    );
    return; 
  }    
            
              // If validation fails, show an alert with errors
              if (!isValid) {
                window.alert(errors.join("\n"));
                return; // Stop execution if validation fails
              }
            
              // Proceed with API call if validation passes
              const FirstName = (this.state as any).FirstName;
              const LastName = (this.state as any).LastName;  
     
              return void this.runCancellableStatefulAsync(
                this,
                {},
                {
                  directorEmail: "",
                },
                async () => {
                  await this.buildPost<IAdministrator, void>(
                    this,
                    "director"
                  )({
                    email: this.state.directorEmail.trim().toLowerCase(),
                    schoolId: this.props.school.id,
                    firstName: FirstName,
                    lastName: LastName,
                    user_id: user?.id,
                    invited_role: "AD"
                  });
            
                  // Reset form fields
                  this.setState((prevState) => ({
                    ...(prevState as any),
                    FirstName: "",
                    LastName: "",
                  }));
            
                  // Reload directors
                  this.loadAdDirectors();
                },
                () => {
                  window.alert(ADD_DIRECTOR_FAILURE);
                }
              );
            };
            
          private readonly addHeadCoach = () => {
            // Extract fields from state
            const coachFirstName = (this.state as any).coachFirstName;
            const coachLastName = (this.state as any).coachLastName;
            const { headCoachEmail, coachSports, headCoachDirectors } = this.state;
               const {
              appContext: { user },
               } = this.props;

          
            // Run validations
            const email = headCoachEmail.trim().toLowerCase();

  // DUPLICATE EMAIL CHECK (Varsity Head Coach list)
  const alreadyExists = headCoachDirectors.some(
    (coach: any) => coach.email?.toLowerCase() === email
  );

  if (alreadyExists) {
    window.alert(
      "This email is already added as a Varsity Head Coach. You can’t add it again."
    );
    return; 
  }
            const { isValid, errors } = this.canSubmit2();
          
            if (!isValid) {
              // Show validation errors in an alert
              window.alert(errors.join("\n"));
              return; // Exit the function if validation fails
            }
          
            // If validation passes, proceed with the API call
            return void this.runCancellableStatefulAsync(
              this,
              {},
              { directorEmail: "" },
              async () => {
                try {
                  const response: any = await this.buildPost<IHeadCoach, void>(
                    this,
                    "/coaches/createHeadCoach"
                  )({
                    email: headCoachEmail.trim().toLowerCase(),
                    schoolId: this.props.school.id,
                    firstName: coachFirstName,
                    lastName: coachLastName,
                    sportId: coachSports,
                    user_id: user?.id,
                    invited_role: "headcoach"
                  });
          
                  console.log("API Response:", response);
          
                  if (response?.status === false) {
                    window.alert(`${ADD_DIRECTOR_FAILURE}: This is the school admin email. Please add a different email for the teacher.`);
                    this.resetFormFields();
                    return;
                  }
                  this.resetFormFields();
                  this.loadAdDirectors();
                } catch (error) {
                  console.error("Error while adding head teacher:", error);
                  this.resetFormFields();
                  window.alert(`${ADD_DIRECTOR_FAILURE}: Error occurred while adding the teacher`);
                }
              },
              () => {
                this.resetFormFields();
                window.alert(`${ADD_DIRECTOR_FAILURE}: Operation was canceled or failed unexpectedly.`);
              }
            );
          };
//            private readonly addSubCoach = () => {
//              const { subCoachName, subCoachEmail, subCoachSports } = this.state;
//               const {
//               appContext: { user },
//                } = this.props;
//   // ---- VALIDATIONS ----
//  if (!subCoachName && (!subCoachSports || subCoachSports.length === 0)) {
//     window.alert("Please enter coach name and select at least one sport.");
//     return;
//   }

//    if (!subCoachName) {
//     window.alert("Please enter coach name.");
//     return;
//   }

//   if (!subCoachSports || subCoachSports.length === 0) {
//     window.alert("Please select at least one sport.");
//     return;
//   }
//   // ---- PAYLOAD ----
//   const payload = {
//     email: subCoachEmail.trim().toLowerCase(),
//     schoolId: this.props.school.id,
//     name: subCoachName,
//     active: false,
//     sports: subCoachSports,
//      user_id: user?.id,
//     invited_role: "coach"
//   };
//   return void this.runCancellableStatefulAsync(
//     this,
//     {},
//     { directorEmail: "" },
//     async () => {
//       try {
//         const response: any = await this.buildPost<ISubCoach, void>(
//           this,
//           "coach"
//         )(payload);

//        console.log("API Response:", response);

//         if (response?.status === false) {
//           window.alert(`${ADD_DIRECTOR_FAILURE}: This is the Main AD`);
//           this.resetFormFields();
//           return;
//         }
//         this.resetFormFields();
//         this.loadAdDirectors();
//       } catch (error) {
//         console.error("Error while adding head coach:", error);
//         this.resetFormFields();
//         window.alert(`${ADD_DIRECTOR_FAILURE}: Error occurred while adding the coach`);
//       }
//     },
//     () => {
//       this.resetFormFields();
//       window.alert(`${ADD_DIRECTOR_FAILURE}: Operation was canceled or failed unexpectedly.`);
//     }
//   );
// };
          
          private resetFormFields = () => {
            this.setState((prevState) => ({
              ...(prevState as any),
              coachFirstName: "",
              coachLastName: "",
              coachSports: [],
              headCoachEmail: "",
              subCoachName: "",
              subCoachEmail: "",
              subCoachSports: []
            }));
          };
        }
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/administrators/administrators.tsx